import axios from "../../config/axiosConfig";
import { CREATE_DELIVERY_CHALLAN_RETURN, GET_DELIVERY_CHALLAN_RETURNS, DELIVERY_CHALLAN_RETURN_REQUEST, UPDATE_DELIVERY_CHALLAN_RETURN,
  DELETE_DELIVERY_CHALLAN_RETURN, DELIVERY_CHALLAN_RETURN_REQUEST_FAILURE, SET_CHALLAN_ORDERS, GET_DELIVERY_CHALLAN_RETURN_PAGE,
  DELIVERY_CHALLAN_RETURN_REQUEST_SUCCESS
} from "../types";
import { getDeliveryChallanReturnTransactionTakaNo } from './delivery-challan-return-transaction-actions';

export const getDeliveryChallanReturnsWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal, getSaleBillStatus) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DELIVERY_CHALLAN_RETURN_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Book_Id,Account_Id,Delivery_Account_Id,Broker_Id,Vehicle_No,Quality',
        getSaleBillStatus
      };
      return axios.get("/delivery-challan-return/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_DELIVERY_CHALLAN_RETURN_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DELIVERY_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELIVERY_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getDeliveryChallanReturnsByRange = (bookId, billId, from, to) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        bookId, billId, from, to
      };
      
      const response = await axios.get("/delivery-challan-return/getAllByRange", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getDeliveryChallanReturnById = (id, getSaleBillStatus) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DELIVERY_CHALLAN_RETURN_REQUEST });
      return axios.get(`/delivery-challan-return/get/${id}`, { params: { getSaleBillStatus } }).then((response) => {
        dispatch({ type: DELIVERY_CHALLAN_RETURN_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DELIVERY_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELIVERY_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });
    }
  };
};


export const getDeliveryChallanReturns = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DELIVERY_CHALLAN_RETURN_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      return axios.get("/delivery-challan-return/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_DELIVERY_CHALLAN_RETURNS, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DELIVERY_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELIVERY_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getAllDeliveryChallanReturns = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DELIVERY_CHALLAN_RETURN_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      return axios.get("/delivery-challan-return/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_DELIVERY_CHALLAN_RETURNS, payload: response.data?.data || [] });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DELIVERY_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELIVERY_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createDeliveryChallanReturn = (deliveryChallanReturn) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: DELIVERY_CHALLAN_RETURN_REQUEST });
      const newDeliveryChallanReturn = {
        ...deliveryChallanReturn
      };
      return axios.post("/delivery-challan-return/add", newDeliveryChallanReturn,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_DELIVERY_CHALLAN_RETURN, payload: response.data });
          dispatch(getDeliveryChallanReturnTransactionTakaNo());
        } else {
          dispatch({
            type: DELIVERY_CHALLAN_RETURN_REQUEST_FAILURE,
            error: "Delivery Challan Return create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DELIVERY_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELIVERY_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateDeliveryChallanReturn = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DELIVERY_CHALLAN_RETURN_REQUEST });
      const { auth } = getState();
      return axios.put("/delivery-challan-return/update", { id, data },
        { params: { 
            userId: auth.user?.id,
            companyId: data.Company_Id || auth.company?.id,
            finyearId: data.Finyear_Id || auth.finyear?.id,
            customerId: data.Customer_Id || auth?.user?.Customer_Id,
          }
        }
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_DELIVERY_CHALLAN_RETURN,
            payload: { id, data: response.data },
          });
          dispatch(getDeliveryChallanReturnTransactionTakaNo());
        } else {
          dispatch({
            type: DELIVERY_CHALLAN_RETURN_REQUEST_FAILURE,
            error: "Delivery Challan Return update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DELIVERY_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELIVERY_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteDeliveryChallanReturn = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DELIVERY_CHALLAN_RETURN_REQUEST });
      const { auth } = getState();
      return axios.delete(`/delivery-challan-return/delete/${id}`, { params: { userId: auth.user?.id } }).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_DELIVERY_CHALLAN_RETURN, id: id });
        }
        dispatch(getDeliveryChallanReturnTransactionTakaNo());
        const include = ['id', 'Challan_No', 'Order_No', 'Book_Id', 'Date', 'Account_Id', 'Delivery_Account_Id', 'Broker_Id', 'Vehicle_No', 'Quality', 'Rate'].join(',');
        const searchCols = ['Challan_No', 'Order_No', 'Book_Id', 'Date', 'Account_Id', 'Delivery_Account_Id', 'Broker_Id', 'Vehicle_No', 'Quality', 'Rate', 'totalWeight', 'totalMeter', 'totalTaka'].join(',');
        const { page, pageSize, searchStr, where,  } = getState()?.inventory?.deliveryChallanReturn || {};
        dispatch(getDeliveryChallanReturnsWithPagination(page, pageSize, include, searchStr, searchCols, where, true));
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DELIVERY_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELIVERY_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
    
  };
};

export const getRemianingSalesOrdersInChallanReturn = (id, bookId) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        // companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        bookId,
        id
      };
      console.log('>>>>>common order', auth?.company?.Common_Order);
      if (!auth?.company?.Common_Order) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get(`/delivery-challan-return/getRemainingOrders`, { params }).then((response) => {
        dispatch({
          type: SET_CHALLAN_ORDERS,
          payload: response.data || [],
        });
        return response.data || [];
      }).catch((error) => {
        dispatch({ type: DELIVERY_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELIVERY_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};